<!--
 * @Author: Ashley.Liu
 * @Date: 2022-12-07 15:15:34
 * @LastEditTime: 2022-12-21 18:13:21
 * @Description: desc
-->
<template>
  <div
    class="as-resize-toolbar"
    :style="isVertical ? 'width: 100%;' : 'height: 100%'"
  >
    <div
      v-if="showResize"
      :class="[
        isVertical ? 'vertical-resize-tool' : 'horizontal-resize-tool',
        resizeToolbarStyleType,
      ]"
    ></div>
    <zm-button
      v-if="showCollapse"
      class="collapse-button"
      :icon="isCollapse ? 'zm-icon-right' : 'zm-icon-left'"
      @click="handleCollapse"
      style="color: #131619"
      size="mini"
    ></zm-button>
  </div>
</template>

<script>
import { Button } from '@zoom/zoom-ui'
export default {
  name: 'ResizeToolbar',
  components: {
    'zm-button': Button,
  },
  props: {
    showResize: {
      type: Boolean,
      default: true,
    },
    isVertical: Boolean,
    collapseHandler: Function,
    showCollapse: Boolean,
    resizeToolbarStyleType: {
      type: String,
      default: 'relative', // relative / absolute
    },
  },
  data() {
    return {
      isCollapse: false,
    }
  },
  methods: {
    handleCollapse() {
      this.isCollapse = !this.isCollapse
      this.collapseHandler && this.collapseHandler(this.isCollapse)
    },
  },
}
</script>

<style lang="scss">
.as-resize-toolbar {
  position: relative;
  @mixin resize {
    font-size: 32px;
    position: relative;
    background: transparent;
    border-color: transparent;
    border-style: solid;
    transition: background-color border-color 0.2s ease-in-out 0s;
  }
  .collapse-button {
    position: absolute;
    top: 120px;
    left: -12px;
    z-index: 99;
    border-radius: 50%;
    box-shadow: 0px 4px 8px rgba(19, 22, 25, 0.1),
      0px 2px 4px rgba(19, 22, 25, 0.1);
  }
  .vertical-resize-tool.relative {
    height: 4px;
    width: 100%;
    cursor: row-resize;
    @include resize;
    &:hover {
      background-color: rgb(87, 148, 242);
    }
  }
  .horizontal-resize-tool.relative {
    width: 4px;
    height: 100%;
    cursor: col-resize;
    @include resize;
    &:hover {
      background-color: rgb(87, 148, 242);
    }
  }
  .vertical-resize-tool.absolute {
    height: 8px;
    width: 100%;
    cursor: row-resize;
    border-width: 0 0 4px;
    @include resize;
    &:hover {
      border-color: rgb(87, 148, 242);
    }
  }
  .horizontal-resize-tool.absolute {
    width: 8px;
    height: 100%;
    cursor: col-resize;
    border-width: 0 0 0 4px;
    @include resize;
    &:hover {
      border-color: rgb(87, 148, 242);
    }
  }
}
</style>
